import { render, staticRenderFns } from "./DesktopNotification.vue?vue&type=template&id=4078fe20&"
import script from "./DesktopNotification.vue?vue&type=script&lang=js&"
export * from "./DesktopNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports